<!--任务详情-->
<template>
  <div class="taskDetial">
    <div class="detialInner">
      <div class="unassigned changeStatus" v-if="formLabelAlign.status == '0'">Unassigned</div>
      <div class="another" style="display: flex;background-color: #D0B9F9;border-radius: 16px"
           v-if="formLabelAlign.status== '1'">
        <div class="assigned">Assigned</div>
        <div class="arrvingTime" v-if="formLabelAlign.estimated_arrival_time">Arrving in
          {{ formLabelAlign.estimated_arrival_time }}
        </div>
      </div>
      <div class="completed changeStatus" v-if="formLabelAlign.status == '3'">Completed</div>
      <div class="another" style="display: flex;background-color: #8DD2FC;border-radius: 16px"
           v-if="formLabelAlign.status== '2'">
        <div class="transit">In Transit</div>
        <div class="arrvingTime" v-if="formLabelAlign.estimated_arrival_time">Arrving in
          {{ formLabelAlign.estimated_arrival_time }}
        </div>
      </div>
      <div class="failed changeStatus" v-if="formLabelAlign.status == '4'">Failed</div>
      <div class="deleted changeStatus" v-if="formLabelAlign.status == '5'">Deleted</div>
    </div>
    <div class="topPans">
      <el-tabs v-model="activeNames" stretch>
        <el-tab-pane label="Information" name="first">
          <el-scrollbar style="height: calc(100vh - 214px)" v-loading="detialLoading">
            <div class="paneOut">
              <el-form label-position="right" label-width="150px" :model="formLabelAlign">
                <div class="paneOne">
                  <el-form-item label="Task ID:">{{ formLabelAlign.task_id }}</el-form-item>
                  <el-form-item label="Invoice#:">{{ formLabelAlign['invoice#'] }}</el-form-item>
                  <el-form-item label="Task type:">
                    <!--                      {{formLabelAlign.type}}-->
                    <div class="third" style="margin-top: 0">
                      <div v-if="formLabelAlign.is_hub == '0'">
                        <div v-if="formLabelAlign.is_pickup == 0 ||formLabelAlign.task_type == 'dropoff'"
                             style="display: flex">
                          <div class="pickup">pickup</div>
                          <div class="yellow">dropoff</div>
                        </div>
                        <div v-else-if="formLabelAlign.is_pickup == 1 || formLabelAlign.task_type == 'pickup'"
                             style="display: flex">
                          <div class="blues">pickup</div>
                          <!--                        这里 drop off 应该为灰色-->
                          <div class="dropoff">dropoff</div>
                        </div>
                      </div>

                      <div v-else-if="formLabelAlign.is_hub == '1'">
                        <div v-if="formLabelAlign.is_pickup == 0 || formLabelAlign.task_type == 'dropoff'"
                             style="display: flex">
                          <div class="hub">hub</div>
                          <div class="yellow">dropoff</div>
                        </div>
                        <div v-else-if="formLabelAlign.is_pickup == 1 ||formLabelAlign.task_type == 'pickup'"
                             style="display: flex">
                          <div class="blues">pickup</div>
                          <div class="hubs">hub</div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="Created by:">{{ formLabelAlign.create_by }}</el-form-item>
                  <el-form-item label="Created at:">{{ formatEventTime(formLabelAlign.create_time) }}</el-form-item>
                  <el-form-item label="Dispatcher:">{{ formLabelAlign.dispatch_name === 'Unknow' ? 'Unknown' : formLabelAlign.dispatch_name }}</el-form-item>
                </div>
                <div class="paneOne">
                  <el-form-item label="Driver:">{{ formLabelAlign.drive }}</el-form-item>
                </div>
                <div class="paneOne paneTwo">
                  <el-form-item>
                    <div slot="label" class="fromLabel" style="margin-bottom: 9px">From</div>
                    <div style="font-weight: bold;color: #1F2D42;line-height: 20px;" v-if="info.is_hub == 1">Hub</div>
                    <div class="changeColor">{{ formLabelAlign.create_by }}</div>
                  </el-form-item>
                  <el-form-item>
                    <div slot="label" class="fromLabel" style="background: #1F2D42">To</div>
                    <div style="font-weight: bold;color: #1F2D42;line-height: 20px;">
                      {{ info.code }}{{ formLabelAlign.recipient_name }}
                    </div>
                    <div class="changeColor">{{ formLabelAlign.abs }}</div>
                    <div class="changeColor">{{ formLabelAlign.address }}</div>
                  </el-form-item>
                </div>
                <div class="paneOne">
                  <el-form-item label="Recipient: ">{{ formLabelAlign.recipient_name }}</el-form-item>
                  <el-form-item label="Phone:">{{ formLabelAlign.phone }}</el-form-item>
                  <el-form-item label="Task detail:">{{ formLabelAlign.task_detail }}</el-form-item>
                </div>

                <div class="paneOne">
                  <el-form-item label="Completed at: ">
                    <span v-if="formLabelAlign.cAt">{{ formLabelAlign.cAt }}</span><span v-else style="color: #999999;">No data</span>
                  </el-form-item>
                  <el-form-item label="Duration: ">
                    <span v-if="formLabelAlign.duration_time">{{ formLabelAlign.duration_time }}</span><span v-else
                                                                                                             style="color: #999999;">No data</span>
                  </el-form-item>
                  <!--                  Distance:-->
                  <el-form-item label="Distance: ">
                    <span v-if="formLabelAlign.distance">{{ formLabelAlign.distance }}</span><span v-else
                                                                                                   style="color: #999999;">No data</span>
                  </el-form-item>
                  <el-form-item label="Completion delay:">

                    <span v-if="formLabelAlign.delay">{{ formLabelAlign.completion_delay }}</span><span v-else
                                                                                                        style="color: #1F2D42;">No delay</span>
                  </el-form-item>
                </div>
                <div class="changeTime">
                  <el-form-item label="Timeline">
                    <div>
                      <el-timeline :reverse="reverse">
                        <el-timeline-item
                          v-for="(activity, index) in formLabelAlign.envent"
                          :key="index"
                          :color="activity.color"
                          placement="top"
                          :timestamp="activity.header">
                          {{ formatEventTime(activity.time) }}
                          <div>
                            <div v-if="activity.note!= ''">note:{{ activity.note }}</div>
                            <div v-if="activity.reason != ''">reason:{{ activity.reason }}</div>
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-scrollbar>
          <div v-if="aid == 1">
            <div class="edit_button" v-if="formLabelAlign.status == 3 || formLabelAlign.status == 4">
              <el-button type="primary" @click="editTaskStatus">Edit Status</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Notes" name="second">
          <div>
            <div class="out_switch_box">
              <div class="out_switch">
                <div class="switch_title">COD order</div>
                <div>
                  <el-switch
                    v-model="cod_order"
                    inactive-text="On"
                    active-color="#82D237"
                    inactive-color="#CCCCCC"
                    @change="changeSwitchHandle"
                  >
                  </el-switch>
                </div>
              </div>
              <div  class="out_switch">
                <div class="switch_title">Delivery delayed</div>
                <div>
                  <el-switch
                    v-model="delivery_delay"
                    inactive-text="On"
                    active-color="#82D237"
                    inactive-color="#CCCCCC"
                    @change="changeSwitchHandle"
                  >
                  </el-switch>
                </div>
              </div>
              <div  class="out_switch">
                <div class="switch_title">Customer complaint</div>
                <div>
                  <el-switch
                    v-model="customer_complaint"
                    inactive-text="On"
                    active-color="#82D237"
                    inactive-color="#CCCCCC"
                    @change="changeSwitchHandle"
                  >
                  </el-switch>
                </div>
              </div>
            </div>
            <div  class="out_note_list">
              <div class="note_title">Note</div>
              <div class="inner_note_list">
                <div v-if="!(formLabelAlign.notes_log && formLabelAlign.notes_log.length)" class="no_note">
                  No record
                </div>
                <div v-else>
                  <div v-for="(item,index) in formLabelAlign.notes_log" :key="index" class="note_list_box">
                    <div>
                      <div class="content_mes mes">{{item.content}}</div>
                      <div class="time_mes mes">{{item.time_desc}}</div>
                    </div>
                    <div style="cursor: pointer;z-index: 999">
                      <img src="../assets/image/delete@2x.png" v-if="item.show_delete" @click="deleteNoteHandle(item)" alt="">
                    </div>
                    <div class="hover-overlay"></div>
                  </div>
                </div>
              </div>
              <div class="btom_buton">
                <el-input v-model="note_input" placeholder="Input your notes"></el-input>
                <el-button type="success" @click="addNewNote" >Submit</el-button>
              </div>
            </div>

          </div>
        </el-tab-pane>
        <el-tab-pane label="Proof" name="third">
          <el-scrollbar style="height: calc(100vh - 200px)">
            <div class="paneImg" style="margin-top: 24px">
              <div v-if="formLabelAlign.photo_url && formLabelAlign.photo_url.length">
                <el-image v-for="(i,v) in formLabelAlign.photo_url" :key="v" :src="i"></el-image>
              </div>
              <div v-else class="empty">
                <img src="../assets/image/list_blank2.png" alt="">
                <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      :modal="false"
      title="Edit task status"
      :visible.sync="change_status_dialog"
      top="5vh"
    >
      <div>
        <el-form :model="profileForm" label-position="top" status-icon ref="ruleForm" :show-message="false">
          <el-form-item label="Status" label-width="120px" required>
            <el-select v-model="profileForm.status_code" popper-class="sb">
              <el-option
                v-for="item in status_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="profileForm.status_code == 0" label="Failure reason" label-width="120px">
            <el-radio-group v-model="profileForm.fail_reson"
                            v-for="(item,index) in fail_reason_list"
                            class="change_status">
              <div>
                <el-radio :label="item"></el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Notes" label-width="120px">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Input some notes for this task"
              v-model="profileForm.status_node">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="change_status_dialog = false" plain>Cancel</el-button>
          <el-button type="primary" @click="saveChagneStatus" round>Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {addNote, changeSwitch, changeTaskStatus, deleteNote, tasksDetialList} from "@/api/tasks";
import {getPublicData} from "@/api/dispatch";

export default {
  name: "taskDetial",
  data() {
    return {
      change_status_dialog: false,
      activeNames: 'first',
      formLabelAlign: {
        notes_log: [],
        envent: [],
        photo_url: [],
      },
      detialLoading: true,
      reverse: false,
      aid: '',
      profileForm: {
        status_code: 1,
        status_node: "",
        fail_reson: "",
      },
      change_task_rules: [],
      status_options: [
        {value: 1, label: 'Completed'},
        {value: 0, label: 'Failed'},
      ],
      fail_reason_list: [],
      cod_order:false,
      delivery_delay:false,
      customer_complaint:false,
      note_input:''
    }
  },
  props: {
    info: {
      default: {}
    },
    show_tag:{
      default: ''
    }
  },
  watch:{
    show_tag:{
      handler(newValue) {
        this.activeNames = newValue || 'first'
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.aid = JSON.parse(localStorage.getItem('userInfo'))?.aid
    getPublicData().then(res => {
      if (res.code == 200) {
        this.fail_reason_list = res.data.failure_reason
      }
    })


  },
  methods: {
    //新增note
    addNewNote(){
      addNote({
        note:this.note_input,
        id:this.info.id,
      }).then(res=>{
        if  (res.code == 200){
          this.note_input = ''
          tasksDetialList({
            id:this.info.id
          }).then(res=>{
            this.formLabelAlign = this.normalizeDetailData(res.data)
          })
          this.$message({
            type:'success',
            message:res.msg
          })
        }else {
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      })
    },
    deleteNoteHandle(e){
      deleteNote({
        id:e.id
      }).then(res=>{
          if (res.code == 200){
            tasksDetialList({
              id:this.info.id
            }).then(res=>{
              this.formLabelAlign = this.normalizeDetailData(res.data)
            })
            this.$message({
              type:'success',
              message:res.msg
            })
          }else {
            this.$message({
              type:'error',
              message:res.msg
            })
          }
      })
    },
    changeSwitchHandle(){
      changeSwitch({
        id:this.info.id,
        cod_order:this.cod_order == true ? '1':'0',
        delivery_delay:this.delivery_delay == true ? '1':'0',
        customer_complaint:this.customer_complaint == true ? '1':'0'
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type:'success',
            message:res.msg
          })
        }else {
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      })
    },
    //修改任务状态
    editTaskStatus() {
      this.change_status_dialog = true
    },
    saveChagneStatus() {
      changeTaskStatus({
        id: this.info.id,
        completion_note: this.profileForm.status_node,
        success: this.profileForm.status_code,
        reason: this.profileForm.fail_reson,
      }).then(res => {
        this.change_status_dialog = false
        this.getData()
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "Edited Successfully"
          })
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },
    formatEventTime(time) {
      if (!time) return ''
      const matched = String(time).match(/^([A-Za-z]+),\s*(\d{1,2})\s+(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)(.*)$/i)
      if (!matched) return time
      const [, month, day, year, hour, minute, ampm, rest] = matched
      return `${month} ${day}, ${year}, ${String(hour).padStart(2, '0')}:${minute} ${ampm.toUpperCase()}${rest}`
    },
    normalizeDetailData(data) {
      const detail = data && typeof data === 'object' ? { ...data } : {}
      if (!Array.isArray(detail.notes_log)) {
        detail.notes_log = []
      }
      if (!Array.isArray(detail.envent)) {
        detail.envent = []
      }
      if (detail.photo_url == null || detail.photo_url === '') {
        detail.photo_url = []
      } else if (!Array.isArray(detail.photo_url)) {
        detail.photo_url = [detail.photo_url]
      }
      const aid = JSON.parse(localStorage.getItem('userInfo') || '{}')?.aid
      detail.notes_log.forEach(v => {
        if (v && v.uid == aid) {
          v.show_delete = true
        }
      })
      return detail
    },
    getData(a) {
      // 每次打开详情默认 Information；外部显式传 show_tag 时按传入 tab
      this.activeNames = this.show_tag || 'first'
      let id = ''
      if (a) {
        id = a
      } else {
        id = this.info.id
      }

      this.detialLoading = true
      tasksDetialList({
        id: id
      }).then(res => {
        this.detialLoading = false
        if (res.code == 200) {
          this.formLabelAlign = this.normalizeDetailData(res.data)
          this.cod_order = this.formLabelAlign.cod_order == 1? true:false
          this.delivery_delay = this.formLabelAlign.delivery_delay == 1? true:false
          this.customer_complaint = this.formLabelAlign.customer_complaint == 1? true:false
          let arr = []
          if (this.formLabelAlign.photo_url.length) {
            this.formLabelAlign.photo_url.forEach(item => {
                arr.push(process.env.VUE_APP_BASE_URL + item)
            })
            this.formLabelAlign.photo_url = arr
            if (this.formLabelAlign.signature_url === ''|| this.formLabelAlign.signature_url === null || this.formLabelAlign.signature_url === undefined ) {
            }else {
              arr.push(process.env.VUE_APP_BASE_URL + this.formLabelAlign.signature_url)
            }
          }

          this.formLabelAlign.envent.forEach(i => {
            switch (i.type) {
              case 0:
                return i.color = '#999999';
              case 1:
                return i.color = '#AB81F3';
              case 2:
                return i.color = '#32B0F8';
              case 3:
                return i.color = '#82D237';
              case 4:
                return i.color = '#E95646';
            }
          })
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          })
          this.$emit('closeDailog')
        }
      }).catch(() => {
        this.detialLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.taskDetial {
  .detialInner {
    .changeStatus {
      color: #FFFFFF;
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
      position: absolute;
      top: 27px;
      left: 140px;
    }

    .unassigned {
      background-color: #BCBEBF;
    }

    .assigned {
      background: #AB81F3;
      border-radius: 16px;
      padding: 0 12px;
      color: #FFFFFF;
      height: 32px;
      line-height: 32px;
      font-size: 13px;
      font-weight: bold;
    }

    .another {
      position: absolute;
      top: 27px;
      left: 140px;
    }

    .completed {
      background-color: #82D237;
    }

    .transit {
      background: #32B0F8;
      border-radius: 16px;
      padding: 0 12px;
      color: #FFFFFF;
      height: 32px;
      line-height: 32px;
      font-size: 13px;
      font-weight: bold;
    }

    .failed {
      background: #E95646;
    }

    .deleted {
      background: #1F2D42;
    }

    .arrvingTime {
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  .change_status {
    width: 100%;
    margin: 8px 0;
  }

  .topPans {
    margin-top: 19px;
    font-size: 14px;
    font-weight: 400;
    color: #1F2D42;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    background: #ECECF2;
   .out_switch_box{
     border-bottom: 1px solid #E0E0E0;
     .out_switch{
       display: flex;
       justify-content: space-between;
       margin: 16px 0;
       .switch_title{
         font-weight: 400;
         font-size: 14px;
         color: #1F2D42;
         line-height: 20px;
       }
     }
   }
    .out_note_list{
      padding-top: 16px;
      .note_title{
        font-family: SFPro, SFPro;
        font-weight: bold;
        font-size: 14px;
        color: #1F2D42;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        margin-bottom: 4px;
      }
      .inner_note_list{
        height: calc(100vh - 424px);
        width: 100%;
        text-align: center;
        overflow: auto;
        .no_note{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: SFPro, SFPro;
          font-weight: 400;
          font-size: 14px;
          color: #CCCCCC;
          line-height: 20px;
          text-align: left;
          font-style: normal;
        }
        .note_list_box{
          position: relative;
          z-index: 2;
          padding: 12px 16px;
          display: flex;
          justify-content: space-between;
          img{
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
          .content_mes{
            color: #1F2D42;
            margin-bottom: 8px;
          }
          .time_mes{
            color: #999999;
          }
          .mes{
            font-family: SFPro, SFPro;
            line-height: 20px;
            font-weight: 400;
            font-size: 14px;
            text-align: left;
            font-style: normal;
          }
        }
        .hover-overlay  {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          transition: background-color 0.3s;
          z-index: 1;
          opacity: 0;
        }
        .note_list_box:hover .hover-overlay  {
          background-color: rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          border: 1px solid #E0E0E0;
          opacity: 1;
        }

      }
      .btom_buton{
        display: flex;
        gap: 8px;
        position: fixed;
        bottom: 48px;
        width: calc(30% - 48px);
      }

    }



    /deep/ .el-tabs__nav {
      background-color: #ECECF2 !important;
      border-radius: 16px;
    }

    /deep/ .el-tabs__header {
      margin: 0;
    }

    /deep/ .el-tabs__nav-scroll {
      padding-left: 0;
    }

    /deep/ .el-tabs__nav-wrap::after {
      background: none;
    }

    /deep/ .el-tabs__item {
      height: 32px;
      line-height: 32px;
      flex: 1;
    }

    /deep/ .el-tabs__item.is-active {
      background: #E95646;
      color: #FFFFFF;
      border-radius: 16px;
    }

    /deep/ .el-tabs__active-bar {
      background: none;
    }

    /deep/ .el-form-item {
      margin: 16px 0;
    }

    /deep/ .el-form-item__label {
      margin: 0;
    }

    .paneOuts {
      text-align: center;
      padding-top: 200px;
    }

    .paneOut {
      padding: 0 20px;
      text-align: left;

      .paneOne {
        border-bottom: 1px solid #E0E0E0;
        //padding: 8px 0;
        .fromLabel {
          margin-left: 43px;
          width: 41px;
          height: 24px;
          line-height: 24px;
          color: #FFFFFF;
          text-align: center;
          background: #E95646;
          border-radius: 8px;
        }

        .changeColor {
          margin: 8px 0;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
        }
      }

      .changeTime {
        /deep/ .el-form-item__label {
          line-height: 8px;
        }
      }

      .paneTwo {
        //padding-top: 16px;
        /deep/ .el-form-item__label {
          display: flex;
          flex-direction: row-reverse;
        }
      }

    }

    .edit_button {
      width: 100%;
      border-top: 1px solid #E0E0E0;
      display: flex;
      flex-direction: row-reverse;
      padding-top: 14px;
      padding-bottom: 14px;
    }

    .empty {
      margin: 0 auto;
      text-align: center;
      transform: translateY(40%);
    }
  }

  .third {
    display: flex;
    padding-right: 5px;
    color: #FFFFFF;
    height: 18px;
    line-height: 18px;
    margin-top: 8px;
    //background-color: #FFC215;
    font-size: 12px;
    border-radius: 4px;

    .hub {
      background-color: #1F2D42;
      border-radius: 4px;
      padding: 0 5px;
    }

    .pickup {
      background: #CCCCCC;
      padding: 0 5px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      //margin-right: 5px;
    }

    //.blue{
    //  background:#1472FF;
    //  padding: 0 5px;
    //  border-top-right-radius: 4px;
    //  border-bottom-right-radius: 4px;
    //  //margin-right: 5px;
    //}
    .blues {
      background: #1472FF;
      padding: 0 9px 0 5px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .hubs {
      background-color: #1F2D42;
      border-radius: 4px;
      padding: 0 5px;
      margin-left: -4px;
    }

    .dropoff {
      background: #CDCCD1;
      padding: 0 5px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      //margin-right: 5px;
    }

    .yellow {
      padding: 0 5px;
      //margin-right: 5px;
      background: #FFC412;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      margin-left: -2px;
    }
  }
}
</style>
